import { useLayoutEffect, useRef, useState } from 'react'
import { Tooltip } from '@mui/material'

// Standard label-on-left, value-on-right row for the report-enquiry General
// Information card. Value column is capped at 70% of the row so the label
// always has breathing room, and the tooltip only fires when the value is
// actually clipped (matches the Workforce slider behaviour).
//
// Tooltip uses MUI directly (instead of the shared MyTooltip wrapper) so the
// `<span>` stays mounted across truncation state changes — the ref and
// ResizeObserver stay attached and hover events fire reliably.
const TOOLTIP_PROPS = {
  tooltip: {
    sx: {
      backgroundColor: '#0C111D',
      padding: '12px',
      borderRadius: '8px',
      boxShadow: '0px 4px 6px -2px #10182808',
    },
  },
  arrow: { sx: { color: '#0C111D !important' } },
}

export default function TruncateRow({
  label,
  value,
  icon = null,
  rowClassName = 'p-4',
}) {
  const ref = useRef(null)
  const [truncated, setTruncated] = useState(false)

  useLayoutEffect(() => {
    const el = ref.current
    if (!el) return undefined
    const check = () => setTruncated(el.scrollWidth > el.clientWidth + 1)
    check()
    const ro = new ResizeObserver(check)
    ro.observe(el)
    return () => ro.disconnect()
  }, [value])

  return (
    <div className={`flex items-center justify-between gap-3 ${rowClassName}`}>
      <span className="shrink-0 text-sm text-gray-500">{label}</span>
      <div className="flex max-w-[70%] min-w-0 items-center justify-end gap-2">
        {icon}
        <Tooltip
          arrow
          placement="top"
          title={truncated ? value : ''}
          componentsProps={TOOLTIP_PROPS}
        >
          <span
            ref={ref}
            className="block w-full truncate text-right text-sm font-semibold text-gray-900"
          >
            {value}
          </span>
        </Tooltip>
      </div>
    </div>
  )
}
